<template>
  <el-table :data="list" border stripe v-loading="loading">
    <el-table-column prop="id" label="记录ID" width="90" align="center" />

    <el-table-column v-if="showUserSummary" label="用户摘要" min-width="180">
      <template slot-scope="{ row }">
        <div class="user-main">
          <div class="user-main__title">{{ row.user_nickname || "--" }}</div>
          <div class="user-main__sub">
            ID {{ row.user_id || "--" }}
          </div>
        </div>
      </template>
    </el-table-column>

    <el-table-column prop="user_id" label="用户ID" width="100" align="center" />
    <!-- <el-table-column prop="ad_tag" label="广告标签" min-width="120" align="center" /> -->
    <!-- <el-table-column prop="type" label="广告类型" min-width="100" align="center" /> -->
    <el-table-column prop="name" label="广告名称" min-width="120" align="center" />
    <!-- <el-table-column prop="trans_id" label="Trans ID" min-width="220" /> -->
    <!-- <el-table-column prop="mediation_rit" label="Mediation RIT" min-width="160" /> -->
    <!-- <el-table-column prop="prime_rit" label="Prime RIT" min-width="140" /> -->
    <!-- <el-table-column prop="reward_name" label="奖励名称" min-width="120" align="center" /> -->
    <!-- <el-table-column prop="reward_amount" label="奖励数量" width="100" align="center" /> -->
    <el-table-column label="ECPM" width="120" align="center">
      <template slot-scope="{ row }">
        {{ formatNumber(row.ecpm) }}
      </template>
    </el-table-column>
    <el-table-column label="分佣状态" width="110" align="center">
      <template slot-scope="{ row }">
        <el-tag :type="String(row.accounting) === '1' ? 'success' : 'danger'">
          {{ String(row.accounting) === "1" ? "已分佣" : "分佣失败" }}
        </el-tag>
      </template>
    </el-table-column>
    <!-- <el-table-column label="ILRD" min-width="180">
      <template slot-scope="{ row }">
        <div class="json-line">{{ row.ilrd || "--" }}</div>
      </template>
    </el-table-column> -->
    <el-table-column label="回调时间" min-width="160" align="center">
      <template slot-scope="{ row }">
        {{ formatTime(row.created_time) }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showUserSummary: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatNumber(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toFixed(2) : "--";
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
  },
};
</script>

<style lang="less" scoped>
.user-main__title {
  font-weight: 600;
  color: #203864;
}

.user-main__sub {
  margin-top: 4px;
  font-size: 12px;
  color: #8090ac;
}

.json-line {
  word-break: break-all;
  color: #516b96;
  line-height: 1.6;
}
</style>
